import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private loaderService = inject(LoaderService);
    private platformId = inject(PLATFORM_ID);

    private requests: HttpRequest<any>[] = [];

    removeRequest(req: HttpRequest<any>) {
        const i = this.requests.indexOf(req);
        if (i >= 0) {
            this.requests.splice(i, 1);
        }
        //console.log(i, this.requests.length);
        this.loaderService.isLoading.next(this.requests.length > 0);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // The loader is a UI spinner with no meaning during SSR, so skip it on the server.
        if (isPlatformServer(this.platformId)) {
            return next.handle(req);
        }
        //console.log("intercept request " + req.url);
        this.requests.push(req);
        setTimeout(() => {
            this.loaderService.isLoading.next(true);
        });

        return new Observable((observer) => {
            const subscription = next.handle(req).subscribe(
                (event) => {
                    if (event instanceof HttpResponse) {
                        // console.log("intercept respose " + event.url);
                        this.removeRequest(req);
                        observer.next(event);
                    }
                },
                (err) => {
                    //this.errorsService.log(err).subscribe();
                    this.removeRequest(req);
                    observer.error(err);
                },
                () => {
                    this.removeRequest(req);
                    observer.complete();
                },
            );
            // teardown logic in case of cancelled requests
            return () => {
                this.removeRequest(req);
                subscription.unsubscribe();
            };
        });
    }
}
